import lpApp from '../lp_app';
import lpevents from '../../tracking/lpevents';
// import { lpPattern } from "../../tracking/pattern_detector";
import { _lp } from '../../logic/wording';
import { setAppState } from '../../redux/actions/app_state';

/*
 * Project: LegalPlace assistant
 * File: src/app/callbacks/basic.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

const UnloadPrompt = (e) => {
  const state = lpApp.getState();
  const event = {};
  if (state.appstate === 0) {
    event['Application phase'] = 'Wizard';
  } else {
    event['Application phase'] = (state.appstate === 1) ? 'Mail section' : 'Checkout';
  }
  event['Last section'] = state.contract && state.contract.currentSection ? parseInt(state.contract.currentSection, 10) + 1 : 'None';
  if (state.appstate > 1) {
    lpevents.track('Closed Checkout', {});
    // pattern.
    if (window.lpPattern) {
      window.lpPattern.trackLastAction('Closed window');
      window.lpPattern.sendAndResetTracker();
    }
  }

  const clientEvent = e || window.event;
  const str = _lp('Etes-vous sûr de vouloir quitter la page ? Pensez à sauvegarder votre document pour le récupérer plus tard');

  // For IE and Firefox
  if (clientEvent) clientEvent.returnValue = str;

  // For Safari
  return str;
};

const historyDispatcher = (evt) => {
  if ((evt.state !== null) && ('store' in evt.state) && ('app_state' in evt.state.store)) {
    const appState = evt.state.store.app_state;
    lpApp.mutex.setMutex('history', false);
    lpApp.dispatch(setAppState(appState === 0 ? 0 : 2));
  }
  if ((evt.state !== null) && ('store' in evt.state) && ('section' in evt.state.store)) {
    const sectionId = evt.state.store.section;
    // console.log(sectionId);
    lpApp.mutex.setMutex('history', false);
    lpApp.dispatch({ type: 'SET_SECTION_ID', id: sectionId });
  }
};


export {
  UnloadPrompt,
  historyDispatcher,
};



// WEBPACK FOOTER //
// ./src/app/callbacks/basic.js